import React from "react";
import { navigationPropType } from "@template/state/modules/navigation";
import CircleImageLink from "@template/components/Navigation/LargeSecondaryNavigation/CircleImageList/CircleImageLink";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";

import styles from "./index.css";

const CircleImageList = ({ item }) => {
  const { label, items, isFirstColumn, isLastColumn } = item;
  const headerId = createIdAriaDescribedBy(label);

  return (
    <ul className={styles.circleImageList} aria-labelledby={headerId}>
      {items.map((itemCircleImage, index) => (
        <CircleImageLink
          item={itemCircleImage}
          key={itemCircleImage.id}
          data-first={isFirstColumn && index === 0 ? true : null}
          data-last={isLastColumn && index === items.length - 1 ? true : null}
        />
      ))}
    </ul>
  );
};

CircleImageList.propTypes = {
  item: navigationPropType.isRequired
};

export default CircleImageList;
